import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ListItem, ListSubheader, Button, SvgIcon, ListItemIcon, ListItemText, Typography } from "@mui/material";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import { SEARCH_ACCELERATORS } from "./config";
import { ResourceType } from "../../../services/types";
import { useGetActiveApp } from "../../../hooks/useGetActiveApp";
interface SearchAcceleratorProps {
  onAcceleratorClick: (type: ResourceType) => void;
}
export const SearchAccelerator: FC<SearchAcceleratorProps> = ({
  onAcceleratorClick,
  ...props
}) => {
  const {
    t
  } = useTranslation();
  const {
    mainApp
  } = useGetActiveApp();
  const isValidApp = Boolean(SEARCH_ACCELERATORS[mainApp as ResourceType]);
  return <>
      {isValidApp && <ListItem {...props} key="SearchAcceleratorSuggestion" sx={{
      height: "36px",
      "&.Mui-focused": {
        borderLeft: "4px solid",
        borderColor: "primary.main",
        backgroundColor: "action.hover",
        pl: 1.5
      }
    }} onClick={() => onAcceleratorClick(mainApp as ResourceType)}>
          <ListItemIcon sx={{
        width: "32px",
        minWidth: "32px"
      }}>
            <ManageSearchRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t("shell.findIn", {
        app: t(SEARCH_ACCELERATORS[mainApp as ResourceType].textKey)
      })} primaryTypographyProps={{
        variant: "body2",
        color: "text.secondary"
      }} />
        </ListItem>}
      <Typography variant="body3" color="text.secondary" sx={{
      pt: 1,
      px: 1.5,
      fontWeight: 600
    }} data-sentry-element="Typography" data-sentry-source-file="SearchAccelerator.tsx">
        {t("shell.searchIn")}
      </Typography>
      <ListItem data-cy="global-search-accelerators" sx={{
      gap: 1,
      pt: 0.5,
      px: 1.5
    }} data-sentry-element="ListItem" data-sentry-source-file="SearchAccelerator.tsx">
        {Object.entries(SEARCH_ACCELERATORS)?.map(([key, value]) => <Button data-cy={`global-search-accelerator-${key}`} key={key} variant="contained" size="small" sx={{
        height: "24px",
        letterSpacing: "0.16px",
        lineHeight: "18px",
        fontWeight: 400
      }} startIcon={<SvgIcon component={value.icon} />} onClick={() => onAcceleratorClick(key as ResourceType)}>
            {t(value.textKey)}
          </Button>)}
      </ListItem>
    </>;
};